import { SalonActionPlan } from '../../types/SalonActionPlan';
import { ActionPlanType, InitiativeType } from '../../types/Initiative';
import { SalonKpiValues } from '../KpiResults/types';
import { CrType } from '../../types/CustomResource';

export const SELECT_INPUT_KPIS: Record<string, Record<string, string>> = {
  tnTransactionsBmrk: SalonKpiValues,
};

export const PLAN_TYPE = {
  guestPlan: { id: 'guestPlan', title: ActionPlanType.guest_plan, field: 'guest_plan' },
  teamPlan: { id: 'teamPlan', title: ActionPlanType.team_plan, field: 'team_plan' },
  higherTicketsPlan: {
    id: 'higherTicketsPlan',
    title: ActionPlanType.higher_tickets_plan,
    field: 'higher_tickets_plan',
  },
} as const satisfies Record<
  'guestPlan' | 'teamPlan' | 'higherTicketsPlan',
  {
    id: keyof SalonActionPlan;
    title: ActionPlanType;
    field: keyof typeof ActionPlanType;
  }
>;

export const PLAN_TYPE_ID_BY_FIELD = Object.fromEntries(
  Object.entries(PLAN_TYPE).map(([key, value]) => [value.field, key]),
) as Record<(typeof PLAN_TYPE)[keyof typeof PLAN_TYPE]['field'], keyof typeof PLAN_TYPE>;

export const RESOURCE_TYPES_BY_TAB_ID = {
  [PLAN_TYPE.guestPlan.field]: [
    { id: CrType.retain, label: InitiativeType.retain },
    { id: CrType.recruit, label: InitiativeType.recruit },
    { id: CrType.both, label: InitiativeType.both },
  ],
  [PLAN_TYPE.teamPlan.field]: [
    { id: CrType.retain, label: InitiativeType.retain },
    { id: CrType.recruit, label: InitiativeType.recruit },
    { id: CrType.both, label: InitiativeType.both },
  ],
  [PLAN_TYPE.higherTicketsPlan.field]: [
    { id: CrType.retailRevenue, label: InitiativeType.retail_revenue },
    { id: CrType.serviceRevenue, label: InitiativeType.service_revenue },
    { id: CrType.both, label: InitiativeType.both },
  ],
};
